module.exports = __webpack_public_path__ + "img/易查X-EPC@2X.9b4475ab.png";